module.exports = __webpack_public_path__ + "static/media/charger-pin-high-power.4c096669.svg";